export default __webpack_public_path__ + "static/media/roboto-slab-400-regular.b46b2661.woff";